import {
  REGISTER_SUCCESS,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
} from "../actions/types";

const initialState = {
  token: null,
  isAuthenticated: null,
  loading: true,
  //user: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'persist/REHYDRATE':
      // Restore persisted auth state; keep loading:true so AuthRefresh
      // can verify the cookie-backed session before PrivateRoute renders anything.
      if (payload?.auth) {
        const { token, ...rest } = payload.auth;
        return { ...state, ...rest, token: null, loading: true };
      }
      return state;
    case USER_LOADED:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        //user: payload,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        //user: payload,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        //user:payload
      };
    case AUTH_ERROR:
    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        //user: null,
      };
    default:
      return state;
  }
}
